var map = {
	"./analysis.svg": "e15b",
	"./compare.svg": "c4db",
	"./consume.svg": "43eb",
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec3",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./info.svg": "4be3",
	"./link.svg": "18f0",
	"./logis.svg": "4722",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./price.svg": "5a55",
	"./rate.svg": "6786",
	"./sale.svg": "2143",
	"./saleStatic.svg": "fc68",
	"./sort.svg": "e528d",
	"./sortSet.svg": "2204",
	"./store.svg": "443b",
	"./sync.svg": "3e1b",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./trend.svg": "c92e",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";